module.exports = __webpack_public_path__ + "img/sign-in.75ff6a9e.png";